import script from "./LinkPlatformGroupsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkPlatformGroupsModal.vue?vue&type=script&setup=true&lang=js"

import "./LinkPlatformGroupsModal.vue?vue&type=style&index=0&id=0b497923&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b497923"]])

export default __exports__